import { mtApi } from 'api'

export interface Cluster {
  id: string
  name: string
  code: string
  priority: string
}
export const fetchClusters = () => mtApi.get<Cluster[]>('/clusters')
